import { emptySplitApi as api } from "../../emptyApi";
const injectedRtkApi = api.injectEndpoints({
  endpoints: (build) => ({
    apiPortalV1FeaturesList: build.query<
      ApiPortalV1FeaturesListApiResponse,
      ApiPortalV1FeaturesListApiArg
    >({
      query: () => ({ url: `/api/portal/v1/features/` }),
    }),
    apiPortalV1FeaturesUpdate: build.mutation<
      ApiPortalV1FeaturesUpdateApiResponse,
      ApiPortalV1FeaturesUpdateApiArg
    >({
      query: (queryArg) => ({
        url: `/api/portal/v1/features/${queryArg.id}/`,
        method: "PUT",
        body: queryArg.feature,
      }),
    }),
    apiPortalV1FeaturesPartialUpdate: build.mutation<
      ApiPortalV1FeaturesPartialUpdateApiResponse,
      ApiPortalV1FeaturesPartialUpdateApiArg
    >({
      query: (queryArg) => ({
        url: `/api/portal/v1/features/${queryArg.id}/`,
        method: "PATCH",
        body: queryArg.patchedFeature,
      }),
    }),
  }),
  overrideExisting: false,
});
export { injectedRtkApi as portalApi };
export type ApiPortalV1FeaturesListApiResponse =
  /** status 200  */ FeatureRead[];
export type ApiPortalV1FeaturesListApiArg = void;
export type ApiPortalV1FeaturesUpdateApiResponse =
  /** status 200  */ FeatureRead;
export type ApiPortalV1FeaturesUpdateApiArg = {
  /** A unique integer value identifying this feature. */
  id: number;
  feature: Feature;
};
export type ApiPortalV1FeaturesPartialUpdateApiResponse =
  /** status 200  */ FeatureRead;
export type ApiPortalV1FeaturesPartialUpdateApiArg = {
  /** A unique integer value identifying this feature. */
  id: number;
  patchedFeature: PatchedFeature;
};
export type Feature = {
  name: string;
  enabled?: boolean;
};
export type FeatureRead = {
  id: number;
  name: string;
  enabled?: boolean;
  parent_feature_id: number | null;
  parent_feature_name: string | null;
};
export type PatchedFeature = {
  name?: string;
  enabled?: boolean;
};
export type PatchedFeatureRead = {
  id?: number;
  name?: string;
  enabled?: boolean;
  parent_feature_id?: number | null;
  parent_feature_name?: string | null;
};
export const {
  useApiPortalV1FeaturesListQuery,
  useApiPortalV1FeaturesUpdateMutation,
  useApiPortalV1FeaturesPartialUpdateMutation,
} = injectedRtkApi;
